module.exports = __webpack_public_path__ + "media/newstyle/images/logo-clube-de-autores-share-0edbddc2ea324c5019fd667a73e95e18.svg";